import { Dropdown } from 'antd';
import { snakeCase } from 'lodash';
import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ReactComponent as SettingsView16 } from 'assets/svgs/settings-view-16.svg';
import { Button } from 'components/atoms/button';
import { Checkbox } from 'components/atoms/checkbox';
import { Menu } from 'components/atoms/dropdown';
import { ProductiveHeading07 } from 'components/styles';
import { ProjectFinancialsContext } from 'contexts/project-financials';

const MenuTitle = styled.div`
  ${ProductiveHeading07};
  padding: 0 var(--spacing-04) var(--spacing-03);
`;

const StyledMenu = styled(Menu)`
  width: 256px;
`;

const StyledMenuItem = styled(Menu.Item)`
  white-space: normal;
  gap: var(--spacing-04);
  align-items: flex-start !important;
`;

const StyledCheckbox = styled(Checkbox)`
  height: auto;
`;

interface Props {
  toggleVisibility: (key: string) => void;
}

export const ProjectFinancialsGranularVisibility: FC<Props> = ({
  toggleVisibility,
}) => {
  const context = useContext(ProjectFinancialsContext);
  const {
    projectFinancialsVisibilityConfig,
    permissionsMap: {
      projectProfitability: { canRead: canViewProfitability },
    },
  } = context;

  return (
    <>
      {Object.keys(projectFinancialsVisibilityConfig).length > 0 && (
        <Dropdown
          overlay={
            <StyledMenu>
              <MenuTitle>
                <FormattedMessage id="project.financials.visibility.title" />
              </MenuTitle>
              {Object.keys(projectFinancialsVisibilityConfig).map(
                (key) =>
                  (key === 'profitabilityData'
                    ? canViewProfitability
                    : true) && (
                    <StyledMenuItem
                      onClick={() => {
                        toggleVisibility(key);
                      }}
                      disabled={
                        key === 'profitabilityData' && !canViewProfitability
                      }
                    >
                      <StyledCheckbox
                        checked={projectFinancialsVisibilityConfig[key]}
                      />
                      <FormattedMessage
                        id={`project.financials.visibility.${snakeCase(key)}`}
                      />
                    </StyledMenuItem>
                  ),
              )}
            </StyledMenu>
          }
          trigger={['click']}
        >
          <Button
            ghost
            icon={<SettingsView16 />}
            type="text"
            size="small"
            onClick={() => {}}
          />
        </Dropdown>
      )}
    </>
  );
};
